export const educationPlanRoute = [{
  path: 'plan-education',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'EducationPlan',
      component: () => import('../../../components/Admin/planEducationAdmin.vue'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'create',
      name: 'EducationPlanCreate',
      component: () => import('../../../components/Admin/CreatePlan.vue'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'edit/:id',
      name: 'EducationPlanEdit',
      component: () => import('../../../components/Admin/EditPlan.vue'),
      meta: {
        access: ['admin']
      }
    }
  ]
}]



// WEBPACK FOOTER //
// /src/router/admin/module/educationPlan.js